export default {
  BusinessUnitSettingsAddAndEdit: 'businessUnitSettingsAddAndEdit',
  BusinessUnitSettingsDelete: 'businessUnitSettingsDelete',
  BusinessAdd: 'businessAdd',
};
